class Header {
  constructor() {
    this.header = document.querySelector(".site-header");
    this.scrollOffset = siteVars.header_sticky_offset;

    // Se l'header è sticky, aggiungi un listener per lo scroll
    if (siteVars.header_sticky) {
      window.addEventListener("scroll", () => this.handleScroll());
    }
  }

  handleScroll() {
    if (window.scrollY > this.scrollOffset) {
      this.header.classList.add("header-scrolled");
    } else {
      this.header.classList.remove("header-scrolled");
    }
  }
}

export default Header;